// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
export function getEndProperty(propIn,propOut){var endProp=false;if(/^Webkit/.test(propIn)){endProp='webkit'+propOut+'End';}else if(/^O/.test(propIn)){endProp='o'+propOut+'End';}else if(propIn){endProp=propOut.toLowerCase()+'end';}return endProp;}